import {
  AccountBalance,
  AccountTree,
  Alarm as AlarmIcon,
  Apps as AppsIcon,
  Assignment as AssignmentIcon,
  Book as BookIcon,
  CreditCard as CreditCardIcon,
  Dangerous,
  Devices as DevicesIcon,
  Groups,
  List as ListIcon,
  ManageSearch,
  Map,
  MonetizationOn,
  NotificationImportant,
  Payment,
  People as PeopleIcon,
  QrCodeScanner as QrIcon,
  SyncAlt as ReconcileIcon,
  ReportGmailerrorred as ReportGmailIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  SyncAlt,
  Person as UserIcon,
  Verified,
  Wallet as WalletIcon,
} from '@mui/icons-material'

export const MENU_ITEMS = [
  {
    id: 'users',
    name: 'Users',
    icon: <PeopleIcon />,
    labelKey: 'menu.users.title',
    permissionTags: ['CORE_USERS_MNU'],
    submenus: [
      {
        id: 'users-list',
        name: 'List',
        url: '/users',
        labelKey: 'menu.users.list',
        icon: <ListIcon />,
        permissionTags: ['CORE_USERS_MNU'],
      },
    ],
  },

  {
    id: 'banking',
    name: 'Banking',
    icon: <AccountBalance />,
    labelKey: 'menu.banking.title',
    permissionTags: ['CORE_BANKING_MNU'],
    submenus: [
      {
        id: 'banking-banks',
        name: 'Banks',
        icon: <AccountBalance />,
        labelKey: 'menu.banking.banks.title',
        permissionTags: ['CORE_BANKS_MNU'],
        submenus: [
          {
            id: 'banking-banks-transactions',
            name: 'List',
            url: '/banking/banks',
            icon: <ListIcon />,
            labelKey: 'menu.banking.banks.transactions',
            permissionTags: ['CORE_BANKS_LIST_MNU'],
          },
        ],
      },
      {
        id: 'banking-cvu',
        name: `CVU's`,
        icon: <WalletIcon />,
        labelKey: 'menu.banking.cvu.title',
        permissionTags: ['CORE_BANKING_CVUS_MNU'],
        submenus: [
          {
            id: 'banking-cvu-list',
            name: 'List',
            url: '/banking/cvu/list',
            icon: <ListIcon />,
            labelKey: 'menu.banking.cvu.list',
            permissionTags: ['CORE_CVU_LIST'],
          },
          {
            id: 'banking-cvu-transactions',
            name: 'Transactions',
            icon: <SyncAlt />,
            url: '/banking/cvu/transactions',
            labelKey: 'menu.banking.cvu.transactions',
            permissionTags: ['CORE_CVU_TRXS'],
          },
          {
            id: 'banking-cvu-blacklist',
            name: 'Blacklist',
            icon: <Dangerous />,
            url: '/banking/cvu/blacklist',
            labelKey: 'menu.banking.cvu.blacklist',
            permissionTags: ['CORE_CVU_BLACK_MENU'],
          },
          {
            id: 'banking-cvu-notifications',
            name: 'Notifications',
            url: '/banking/cvu/notifications',
            icon: <NotificationImportant />,
            labelKey: 'menu.banking.cvu.notifications',
            permissionTags: ['CORE_CVU_NOTIF_MNU'],
          },
        ],
      },
      {
        id: 'banking-cvu-ach',
        name: 'ACH',
        icon: <ReconcileIcon />,
        labelKey: 'menu.banking.ach.title',
        permissionTags: ['CORE_CVU_ACH_MNU'],
        submenus: [
          {
            id: 'banking-cvu-ach-transactions',
            name: 'Transactions',
            url: '/banking/ach/transactions',
            icon: <SyncAlt />,
            labelKey: 'menu.banking.ach.transactions',
            permissionTags: ['CORE_CVU_ACH_TRXS_MNU'],
          },
          {
            id: 'banking-cvu-ach-provisioning',
            name: 'Provisioning',
            url: '/banking/ach/provisioning',
            icon: <SyncAlt />,
            labelKey: 'menu.banking.ach.provisioning',
            permissionTags: ['CORE_ACH_PROV_MNU'],
          },
        ],
      },
    ],
  },

  {
    id: 'cards',
    name: 'Cards',
    icon: <CreditCardIcon />,
    labelKey: 'menu.cards.title',
    permissionTags: ['CORE_CARDS_MNU'],
    submenus: [
      {
        id: 'cards-list',
        name: 'List',
        url: '/cards',
        icon: <ListIcon />,
        labelKey: 'menu.cards.list',
        permissionTags: ['CORE_CARDS_LIST'],
      },
      {
        id: 'cards-transactions',
        name: 'Transactions',
        url: '/cards/transactions',
        icon: <SyncAlt />,
        labelKey: 'menu.cards.transactions',
        permissionTags: ['CORE_CARDS_TRXS'],
      },
    ],
  },
  {
    id: 'checks',
    name: 'Checks',
    url: '/checks',
    icon: <Payment />,
    labelKey: 'menu.checks.title',
    permissionTags: ['CORE_CHECKS_MNU'],
  },
  {
    id: 'accounting',
    name: 'Accounting',
    icon: <MonetizationOn />,
    labelKey: 'menu.accounting.title',
    permissionTags: ['CORE_ACCT_MENU'],
    submenus: [
      {
        id: 'reconcile',
        name: 'Reconcile',
        icon: <ReconcileIcon />,
        labelKey: 'menu.accounting.reconcile.title',
        permissionTags: ['CORE_ACCT_RECON_MENU'],
        submenus: [
          {
            id: 'red-link',
            name: 'Red Link',
            url: '/accounting/reconcile/redlink',
            icon: <QrIcon />,
            labelKey: 'menu.accounting.reconcile.redLink',
            permissionTags: ['CORE_ACCT_RECON_REDLINK_MENU'],
          },
        ],
      },
    ],
  },

  {
    id: 'taxes',
    name: 'Taxes',
    icon: <Map />,
    labelKey: 'menu.taxes.title',
    permissionTags: ['CORE_TAX_MENU'],
    submenus: [
      {
        id: 'taxes-arg',
        name: 'Argentina',
        icon: <AccountBalance />,
        labelKey: 'menu.taxes.argentina.title',
        permissionTags: ['CORE_TAX_ARG_MENU'],
        submenus: [
          {
            id: 'taxes-arg-ibba',
            name: 'IIBB',
            icon: <MonetizationOn />,
            labelKey: 'menu.taxes.argentina.iibb.title',
            permissionTags: ['CORE_TAX_ARG_IIBB_MENU'],
            submenus: [
              {
                id: 'taxes-arg-ibba-master',
                name: 'Master',
                url: '/taxes/arg/ibba/master',
                icon: <MonetizationOn />,
                labelKey: 'menu.taxes.argentina.iibb.master',
                permissionTags: ['CORE_TAX_ARG_IIBB_MASTER_MENU'],
              },
              {
                id: 'taxes-arg-ibba-groups',
                name: 'Groups',
                url: '/taxes/arg/ibba/groups',
                icon: <Groups />,
                labelKey: 'menu.taxes.argentina.iibb.groups',
                permissionTags: ['CORE_TAX_ARG_IIBB_MASTER_MENU'],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    id: 'compliance',
    name: 'Compliance',
    icon: <SecurityIcon />,
    labelKey: 'menu.compliance.title',
    permissionTags: ['CORE_USR_COMPLIANCE_MENU'],
    submenus: [
      {
        id: 'verifications',
        name: 'Verifications',
        url: '/verifications',
        icon: <UserIcon />,
        labelKey: 'menu.compliance.verifications',
        permissionTags: ['CORE_COMPLIANCE_VERIFICATIONS_MENU'],
      },
      {
        id: 'nosis-verifications',
        name: 'Nosis',
        icon: <Verified />,
        labelKey: 'menu.compliance.nosis.title',
        permissionTags: ['CORE_COMPLIANCE_NOSIS_MENU'],
        submenus: [
          {
            id: 'nosis-verifications-queries',
            name: 'Consultas',
            url: '/compliance/nosis/queries',
            icon: <ManageSearch />,
            labelKey: 'menu.compliance.nosis.queries',
            permissionTags: ['CORE_COMPLIANCE_NOSIS_MENU'],
          },
        ],
      },
      {
        id: 'profiles',
        name: 'Profiles',
        url: '/settings/profiles',
        icon: <UserIcon />,
        labelKey: 'menu.compliance.profiles',
        permissionTags: ['CORE_COMPLIANCE_PROFILES_MENU'],
      },
      {
        id: 'rules',
        name: 'Rules',
        url: '/compliance/rules',
        icon: <BookIcon />,
        labelKey: 'menu.compliance.rules',
        permissionTags: ['CORE_COMPLIANCE_RULES_MENU'],
      },
      {
        id: 'alerts',
        name: 'Alerts',
        url: '/settings/alerts',
        icon: <AlarmIcon />,
        labelKey: 'menu.compliance.alerts',
        permissionTags: ['CORE_COMPLIANCE_ALERTS'],
      },
    ],
  },

  {
    id: 'feeses',
    name: 'Feeses',
    icon: <AccountTree />,
    labelKey: 'menu.feeses.title',
    permissionTags: ['CORE_FEESES_MNU'],
    submenus: [
      {
        id: 'default-settings',
        name: 'Default Settings',
        url: '/fees/default',
        icon: <AccountTree />,
        labelKey: 'menu.feeses.defaultSettings',
        permissionTags: ['CORE_FEESES_DEFAULT_MNU'],
      },
      {
        id: 'custom-settings',
        name: 'Custom Settings',
        url: '/fees/custom',
        icon: <AccountTree />,
        labelKey: 'menu.feeses.customSettings',
        permissionTags: ['CORE_FEESES_CUSTOM_MNU'],
      },
    ],
  },
  {
    id: 'request',
    name: 'Request',
    url: '/request',
    icon: <AssignmentIcon />,
    labelKey: 'menu.request.title',
    permissionTags: [],
  },
  {
    id: 'settings',
    name: 'Settings',
    icon: <SettingsIcon />,
    labelKey: 'menu.settings.title',
    permissionTags: ['CORE_SETTINGS_MNU'],
    submenus: [
      {
        id: 'settings-general',
        name: 'General',
        url: '/settings/general',
        icon: <AppsIcon />,
        labelKey: 'menu.settings.general',
        permissionTags: ['CORE_SETTINGS_GENERAL_MNU'],
      },
      {
        id: 'collaborators',
        name: 'Collaborators',
        url: '/settings/collaborators',
        icon: <PeopleIcon />,
        labelKey: 'menu.settings.collaborators',
        permissionTags: ['CORE_SETTINGS_COLLABORATORS_MNU'],
      },
      {
        id: 'types',
        name: 'Element Types',
        url: '/settings/types',
        icon: <AppsIcon />,
        labelKey: 'menu.settings.elementTypes',
        permissionTags: ['CORE_ELEMTYPE_MNU'],
      },
      {
        id: 'subtypes',
        name: 'Element SubTypes',
        url: '/settings/subtypes',
        icon: <AppsIcon />,
        labelKey: 'menu.settings.elementSubtypes',
        permissionTags: ['CORE_ELEMSUBTYPE_MNU'],
      },
      {
        id: 'apps',
        name: 'Apps',
        url: '/settings/apps',
        icon: <AppsIcon />,
        labelKey: 'menu.settings.apps',
        permissionTags: ['CORE_SETTINGS_APPS_MNU'],
      },
      {
        id: 'roles',
        name: 'Roles',
        url: '/settings/roles',
        icon: <SecurityIcon />,
        labelKey: 'menu.settings.roles',
        permissionTags: ['CORE_SETTINGS_ROLES_MNU'],
      },
      {
        id: 'users-roles',
        name: 'Users Roles',
        url: '/users_roles',
        icon: <UserIcon />,
        labelKey: 'menu.settings.usersRoles',
        permissionTags: ['CORE_USR_ROLES'],
      },
      {
        id: 'functionalities',
        name: 'Functionalities',
        url: '/settings/functionalities',
        icon: <AppsIcon />,
        labelKey: 'menu.settings.functionalities',
        permissionTags: ['CORE_FUNCT_MNU'],
      },
      {
        id: 'scopes',
        name: 'Scopes',
        url: '/settings/scopes',
        icon: <DevicesIcon />,
        labelKey: 'menu.settings.scopes',
        permissionTags: ['SUPERADMIN'],
      },
      {
        id: 'activities',
        name: 'activities',
        url: '/settings/activities',
        icon: <DevicesIcon />,
        labelKey: 'menu.settings.activities',
        permissionTags: [],
      },
    ],
  },
]
